import { render, staticRenderFns } from "./editDepartment.vue?vue&type=template&id=fc0be800&scoped=true"
import script from "./editDepartment.vue?vue&type=script&lang=js"
export * from "./editDepartment.vue?vue&type=script&lang=js"
import style0 from "./editDepartment.vue?vue&type=style&index=0&id=fc0be800&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0be800",
  null
  
)

export default component.exports